module.exports = __webpack_public_path__ + "img/dark-mode-icon.9415f02a.svg";